// sort-imports-ignore
/* eslint-disable import/first */
// Import polyfills and setup error reporting system
import "./_bootstrap";
import {
    Provider as ReactivatedProvider,
    getServerData,
    getTemplate,
} from "@reactivated";
import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import { initPage } from "@thelabnyc/thelabui/src/index";
import { getDocument, getWindow } from "@thelabnyc/thelabui/src/utils/dom";
import Modal from "react-modal";
import { trackPageView } from "tsi-common-react/src/utils/analytics";
import { onDOMContentLoaded } from "tsi-common-react/src/utils/events";
import { initWidgets } from "tsi-common-react/src/forms/initWidgets";
import { store } from "./store";

// Load CSS
import "./styles/main.scss";

// Set tsi-common-react configuration
import "./localization";

const Provider = (props: React.ComponentProps<typeof ReactivatedProvider>) => {
    const { children, ...otherProps } = props;
    return (
        <ReactivatedProvider {...otherProps}>
            <ReduxProvider store={store}>{children}</ReduxProvider>
        </ReactivatedProvider>
    );
};

// In Vite dev mode, this module can execute twice under different URLs
// (bare vs ?t= cache-busted). Every module-level initialization must run
// exactly once: a second pass double-hydrates, double-registers analytics,
// and double-binds the initWidgets event handlers (paired class/aria
// toggles then cancel each other out -- e.g. accordions stop opening).
// Side-effect imports below are safe: child module URLs are canonical, so
// Vite caches them across both entry executions.
const _w = getWindow() as (Window & Record<string, unknown>) | null;
if (!_w?.["__tsi_initPage"]) {
    if (_w) _w["__tsi_initPage"] = true;
    initPage({
        Provider,
        getServerData,
        getTemplate,
    }).catch((e) => {
        console.error(e);
    });

    // Set the root app element for react-modal
    const document = getDocument();
    if (document?.querySelector("#content")) {
        Modal.setAppElement("#content");
    } else if (document?.querySelector("#root")) {
        Modal.setAppElement("#root");
    }

    // Configure analytics
    onDOMContentLoaded.on(() => {
        trackPageView().catch(() => {});
    });

    // Application Components
    initWidgets();
}

// React Components
import "./init";
import "./apps/checkout/index";
import "./apps/reviews/index";
